export default __webpack_public_path__ + "static/media/raw-process.bd8c688b.jpg";